import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { VenueAccessStore } from '../stores/venue-access.store';

/**
 * Keeps a direct URL or bookmark from opening a Premium form the server would refuse only after
 * the owner filled it in. Denied access lands on the feature's list, which explains the lock and
 * still offers everything that stays free, such as switching a discount off.
 */
export function premiumGuard(fallback: string): CanActivateFn {
  return async () => {
    const venueAccess = inject(VenueAccessStore);
    const router = inject(Router);

    await venueAccess.load();

    return venueAccess.hasPremium() ? true : router.parseUrl(fallback);
  };
}
